import { useQueryClient } from '@tanstack/react-query';
import useDeleteInternalCustomDataField from 'components/domain/customData/fields/internal/useDeleteInternalCustomDataField';
import { INTERNAL_CUSTOM_DATA_FIELDS_BASE_QUERY_KEY } from 'components/domain/customData/fields/internal/useFetchInternalCustomDataFields';
import useAppModal from 'hooks/useAppModal';
import useNotify from 'hooks/useNotify';
import { useTranslation } from 'react-i18next';

const useDeleteCustomFieldModal = ({
  uid,
  name,
}: {
  uid: string;
  name: string;
}) => {
  const queryClient = useQueryClient();
  const { notifyError } = useNotify();
  const { t } = useTranslation();
  const { deleteInternalCustomField } = useDeleteInternalCustomDataField();
  const { openConfirmModal } = useAppModal();

  const handleDelete = async () => {
    await deleteInternalCustomField(uid)
      .then(() => {
        queryClient.invalidateQueries({
          queryKey: [INTERNAL_CUSTOM_DATA_FIELDS_BASE_QUERY_KEY],
        });
      })
      .catch(() => {
        notifyError(t('pageAutomations.preArrivalForm.deleteModal.error'));
      });
  };

  const openDeleteModal = () => {
    openConfirmModal({
      body: t('pageAutomations.preArrivalForm.deleteModal.description', {
        name,
      }),
      title: t('pageAutomations.preArrivalForm.deleteModal.title'),
      onConfirmAsync: handleDelete,
      confirmColor: 'danger',
      confirmLabel: t('common.delete'),
    });
  };

  return {
    openDeleteModal,
  };
};

export default useDeleteCustomFieldModal;
